export default __webpack_public_path__ + "static/media/Acolyte's Gloves of the Limitless Cipher.f1d9d7ee.jpg";